module.exports = __webpack_public_path__ + "static/media/spot9.0c094e40.webp";